import { render, staticRenderFns } from "./ManageDeliveryFors.vue?vue&type=template&id=ebf3b83a&scoped=true"
import script from "./ManageDeliveryFors.vue?vue&type=script&lang=ts"
export * from "./ManageDeliveryFors.vue?vue&type=script&lang=ts"
import style0 from "./ManageDeliveryFors.vue?vue&type=style&index=0&id=ebf3b83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf3b83a",
  null
  
)

export default component.exports